export const anchor = (id: string) => {
    if (typeof document !== 'undefined') {
        const target = document.querySelector(`#${id}`);
        if (target) window.scrollTo(0, target.getBoundingClientRect().y + 10);
    }
};
